import _ from 'lodash';

class ShopCartService {
    /*@ngInject*/
    constructor($rootScope, constants, dataContext, cartService, $window, alertService) {
        this.$rootScope = $rootScope;
        this.dataContext = dataContext;
        this.cartService = cartService;
        this.constants = constants;
        this.$window = $window;
        this.alertService = alertService;
    }

    validateCartItems(quantityToBeAdded, max, sku, name) {
        let eligible = true;
        let accountCount = 0;

        return this.cartService.getCart()
            .then((cartData) => {
                const cartCount = _.filter(cartData.data.items, o => o.sku === sku).length;
                return this.dataContext.product.getActiveEquipments()
                    .then((equipmentData) => {
                        // Check if we're adding a hub or keypad 
                        if ((_.filter(this.constants.skus.frontpointHubManufacturerSkus, o => o === sku).length > 0) ||
                        (_.filter(this.constants.skus.frontpointKeypadManufacturerSkus, o => o === sku).length > 0)) {
                            if (_.filter(this.constants.skus.frontpointHubManufacturerSkus, o => o === sku).length > 0) {
                                accountCount = _.filter(equipmentData.map(p => p.SKUManufacturer),
                                    o => this.constants.skus.frontpointHubManufacturerSkus.includes(o)).length;
                            }
                            else if (_.filter(this.constants.skus.frontpointKeypadManufacturerSkus, o => o === sku)
                                .length > 0) {
                                accountCount = _.filter(equipmentData.map(p => p.SKUManufacturer),
                                    o => this.constants.skus.frontpointKeypadManufacturerSkus.includes(o)).length;
                            }
                        } else {
                            accountCount = _.filter(equipmentData, o => o.SKUManufacturer === sku)
                                .length;
                        }

                        const totalCount = accountCount + cartCount + quantityToBeAdded;

                        // if the max quantity for a product is set to 0, we don't need to validateMaxAmount
                        if (max == 0) {
                            return eligible;
                        }

                        eligible = this.validateMaxAmount(totalCount, accountCount, max, name, cartCount );
                        return eligible;
                    });
            });
    }

    validateCartChange(quantity, max, fpwsSku, name) {
        let eligible = true;
        return this.dataContext.product.getActiveEquipments()
            .then((equipmentData) => {
                const accountCount =
                    _.filter(equipmentData, o => o.SKUManufacturer === fpwsSku).length;
                const totalCount = accountCount + quantity;
                eligible = this.validateMaxAmount(totalCount, accountCount, max, name);
                return eligible;
            });
    }

    validateMaxAmount(totalCount, accountCount, maxAllowed, name, cartTotal) {
        if (totalCount > maxAllowed) {
            let balance = 0;
            if (accountCount < maxAllowed) {
                balance = maxAllowed - totalCount;
            }
            if (Math.sign(balance) === -1) {
                balance = 0;
            }
            let keypadMessage = `Your account supports ${maxAllowed} ${name}${maxAllowed > 1 ? 's': ''} at a time.`;
            if (!_.isNil(cartTotal) && cartTotal > 0){
                keypadMessage += ` You have ${cartTotal} in your cart.`;
            }
            if (!_.isNil(accountCount)){
                keypadMessage += ` You have ${accountCount} already on your account.`;
            }
            const alertDialog = 'Keypad error';
            this.alertService
                .get(alertDialog)
                .setMessage(keypadMessage)
                .setType('warning')
                .open();
            this.$window.scrollTo(0, 0);
            return false;
        }
        return true;
    }

}

export default ShopCartService;